import { render } from "./page-archives-section.vue?vue&type=template&id=1cf8fdee&scoped=true"
import script from "./page-archives-section.vue?vue&type=script&lang=js"
export * from "./page-archives-section.vue?vue&type=script&lang=js"

import "./page-archives-section.vue?vue&type=style&index=0&id=1cf8fdee&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf8fdee"],['__file',"src/components/notepad/pages/page-archives-section.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cf8fdee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cf8fdee', __exports__)) {
    api.reload('1cf8fdee', __exports__)
  }
  
  module.hot.accept("./page-archives-section.vue?vue&type=template&id=1cf8fdee&scoped=true", () => {
    api.rerender('1cf8fdee', render)
  })

}


export default __exports__